import { isBoolean, entries, has, find, cloneDeep, keyBy } from 'lodash-es';
import axios from 'axios';
import { withQuery } from 'ufo';
import { unref, ref } from 'vue-demi';
import { useStorage } from '@vueuse/core';

const instance = axios.create();
instance.interceptors.request.use((config) => {
  const { source, channel, shopToken } = getGlobalConfig();
  config.headers = Object.assign(config.headers, { source, channel, space_token: shopToken });
  return config;
}, (error) => {
  return Promise.reject(error);
});
instance.interceptors.response.use((config) => {
  const { status, data } = config;
  if (status !== 200)
    return Promise.reject(data);
  if (data.code !== 200)
    return Promise.reject(data);
  if (data.pages)
    return config.data;
  else
    return config.data.data ?? null;
}, (error) => {
  return Promise.reject(error);
});
async function requestAxios(url, config) {
  try {
    return await instance(url, config);
  } catch (error) {
    return Promise.reject(error);
  }
}
async function shopHttp(url, options) {
  const config = getGlobalConfig();
  return requestAxios(url, { baseURL: config.baseUrl, ...options });
}

async function getShopCommodityListApi() {
  const { locale, currency } = getGlobalConfig();
  const typeMap = {
    \u79FB\u52A8\u6E38\u620F: "mobile",
    PC\u6E38\u620F: "pc",
    \u5E94\u7528: "app"
  };
  const groups = await shopHttp("/api/distributes/{locale}/union/commodity" /* GOODS_LIST */.replace("{locale}", locale), { method: "post", data: { version: "v3", currency } });
  groups.forEach((i) => {
    i.key = typeMap[i.categoryName];
  });
  return groups;
}
function getShopCommodityDetailApi({ id: commodityId, type }) {
  const { locale, currency } = getGlobalConfig();
  return shopHttp("/api/mall/commodity/id/full" /* GOOD_DETAIL */, { method: "get", params: { commodityId, type, region: locale, currency } });
}
function getShopCommodityByPkg(packageName) {
  const { locale, currency } = getGlobalConfig();
  return shopHttp("/api/{locale}/game/commodity" /* GOOD_SEARCH_BY_PKG */.replace("{locale}", locale), { method: "get", params: { packageName, currency } });
}

function getShopCurrencyListApi() {
  const { locale } = getGlobalConfig();
  return shopHttp("/api/exchangeRate/currency/list" /* CURRENCY_LIST */, { method: "get", params: { region: locale } });
}
function getShopCustomTranslateApi() {
  return shopHttp("/api/translation/content" /* TRANSLATION_CONTENT */, { method: "get" });
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var md5$1 = {exports: {}};

function commonjsRequire(path) {
	throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}

var core = {exports: {}};

var hasRequiredCore;

function requireCore () {
	if (hasRequiredCore) return core.exports;
	hasRequiredCore = 1;
	(function (module, exports) {
(function (root, factory) {
			{
				// CommonJS
				module.exports = factory();
			}
		}(commonjsGlobal, function () {

			/*globals window, global, require*/

			/**
			 * CryptoJS core components.
			 */
			var CryptoJS = CryptoJS || (function (Math, undefined$1) {

			    var crypto;

			    // Native crypto from window (Browser)
			    if (typeof window !== 'undefined' && window.crypto) {
			        crypto = window.crypto;
			    }

			    // Native crypto in web worker (Browser)
			    if (typeof self !== 'undefined' && self.crypto) {
			        crypto = self.crypto;
			    }

			    // Native crypto from worker
			    if (typeof globalThis !== 'undefined' && globalThis.crypto) {
			        crypto = globalThis.crypto;
			    }

			    // Native (experimental IE 11) crypto from window (Browser)
			    if (!crypto && typeof window !== 'undefined' && window.msCrypto) {
			        crypto = window.msCrypto;
			    }

			    // Native crypto from global (NodeJS)
			    if (!crypto && typeof commonjsGlobal !== 'undefined' && commonjsGlobal.crypto) {
			        crypto = commonjsGlobal.crypto;
			    }

			    // Native crypto import via require (NodeJS)
			    if (!crypto && typeof commonjsRequire === 'function') {
			        try {
			            crypto = require('crypto');
			        } catch (err) {}
			    }

			    /*
			     * Cryptographically secure pseudorandom number generator
			     *
			     * As Math.random() is cryptographically not safe to use
			     */
			    var cryptoSecureRandomInt = function () {
			        if (crypto) {
			            // Use getRandomValues method (Browser)
			            if (typeof crypto.getRandomValues === 'function') {
			                try {
			                    return crypto.getRandomValues(new Uint32Array(1))[0];
			                } catch (err) {}
			            }

			            // Use randomBytes method (NodeJS)
			            if (typeof crypto.randomBytes === 'function') {
			                try {
			                    return crypto.randomBytes(4).readInt32LE();
			                } catch (err) {}
			            }
			        }

			        throw new Error('Native crypto module could not be used to get secure random number.');
			    };

			    /*
			     * Local polyfill of Object.create

			     */
			    var create = Object.create || (function () {
			        function F() {}

			        return function (obj) {
			            var subtype;

			            F.prototype = obj;

			            subtype = new F();

			            F.prototype = null;

			            return subtype;
			        };
			    }());

			    /**
			     * CryptoJS namespace.
			     */
			    var C = {};

			    /**
			     * Library namespace.
			     */
			    var C_lib = C.lib = {};

			    /**
			     * Base object for prototypal inheritance.
			     */
			    var Base = C_lib.Base = (function () {


			        return {
			            /**
			             * Creates a new object that inherits from this object.
			             *
			             * @param {Object} overrides Properties to copy into the new object.
			             *
			             * @return {Object} The new object.
			             *
			             * @static
			             *
			             * @example
			             *
			             *     var MyType = CryptoJS.lib.Base.extend({
			             *         field: 'value',
			             *
			             *         method: function () {
			             *         }
			             *     });
			             */
			            extend: function (overrides) {
			                // Spawn
			                var subtype = create(this);

			                // Augment
			                if (overrides) {
			                    subtype.mixIn(overrides);
			                }

			                // Create default initializer
			                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
			                    subtype.init = function () {
			                        subtype.$super.init.apply(this, arguments);
			                    };
			                }

			                // Initializer's prototype is the subtype object
			                subtype.init.prototype = subtype;

			                // Reference supertype
			                subtype.$super = this;

			                return subtype;
			            },

			            /**
			             * Extends this object and runs the init method.
			             * Arguments to create() will be passed to init().
			             *
			             * @return {Object} The new object.
			             *
			             * @static
			             *
			             * @example
			             *
			             *     var instance = MyType.create();
			             */
			            create: function () {
			                var instance = this.extend();
			                instance.init.apply(instance, arguments);

			                return instance;
			            },

			            /**
			             * Initializes a newly created object.
			             * Override this method to add some logic when your objects are created.
			             *
			             * @example
			             *
			             *     var MyType = CryptoJS.lib.Base.extend({
			             *         init: function () {
			             *             // ...
			             *         }
			             *     });
			             */
			            init: function () {
			            },

			            /**
			             * Copies properties into this object.
			             *
			             * @param {Object} properties The properties to mix in.
			             *
			             * @example
			             *
			             *     MyType.mixIn({
			             *         field: 'value'
			             *     });
			             */
			            mixIn: function (properties) {
			                for (var propertyName in properties) {
			                    if (properties.hasOwnProperty(propertyName)) {
			                        this[propertyName] = properties[propertyName];
			                    }
			                }

			                // IE won't copy toString using the loop above
			                if (properties.hasOwnProperty('toString')) {
			                    this.toString = properties.toString;
			                }
			            },

			            /**
			             * Creates a copy of this object.
			             *
			             * @return {Object} The clone.
			             *
			             * @example
			             *
			             *     var clone = instance.clone();
			             */
			            clone: function () {
			                return this.init.prototype.extend(this);
			            }
			        };
			    }());

			    /**
			     * An array of 32-bit words.
			     *
			     * @property {Array} words The array of 32-bit words.
			     * @property {number} sigBytes The number of significant bytes in this word array.
			     */
			    var WordArray = C_lib.WordArray = Base.extend({
			        /**
			         * Initializes a newly created word array.
			         *
			         * @param {Array} words (Optional) An array of 32-bit words.
			         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
			         *
			         * @example
			         *
			         *     var wordArray = CryptoJS.lib.WordArray.create();
			         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
			         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
			         */
			        init: function (words, sigBytes) {
			            words = this.words = words || [];

			            if (sigBytes != undefined$1) {
			                this.sigBytes = sigBytes;
			            } else {
			                this.sigBytes = words.length * 4;
			            }
			        },

			        /**
			         * Converts this word array to a string.
			         *
			         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
			         *
			         * @return {string} The stringified word array.
			         *
			         * @example
			         *
			         *     var string = wordArray + '';
			         *     var string = wordArray.toString();
			         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
			         */
			        toString: function (encoder) {
			            return (encoder || Hex).stringify(this);
			        },

			        /**
			         * Concatenates a word array to this word array.
			         *
			         * @param {WordArray} wordArray The word array to append.
			         *
			         * @return {WordArray} This word array.
			         *
			         * @example
			         *
			         *     wordArray1.concat(wordArray2);
			         */
			        concat: function (wordArray) {
			            // Shortcuts
			            var thisWords = this.words;
			            var thatWords = wordArray.words;
			            var thisSigBytes = this.sigBytes;
			            var thatSigBytes = wordArray.sigBytes;

			            // Clamp excess bits
			            this.clamp();

			            // Concat
			            if (thisSigBytes % 4) {
			                // Copy one byte at a time
			                for (var i = 0; i < thatSigBytes; i++) {
			                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
			                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
			                }
			            } else {
			                // Copy one word at a time
			                for (var j = 0; j < thatSigBytes; j += 4) {
			                    thisWords[(thisSigBytes + j) >>> 2] = thatWords[j >>> 2];
			                }
			            }
			            this.sigBytes += thatSigBytes;

			            // Chainable
			            return this;
			        },

			        /**
			         * Removes insignificant bits.
			         *
			         * @example
			         *
			         *     wordArray.clamp();
			         */
			        clamp: function () {
			            // Shortcuts
			            var words = this.words;
			            var sigBytes = this.sigBytes;

			            // Clamp
			            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
			            words.length = Math.ceil(sigBytes / 4);
			        },

			        /**
			         * Creates a copy of this word array.
			         *
			         * @return {WordArray} The clone.
			         *
			         * @example
			         *
			         *     var clone = wordArray.clone();
			         */
			        clone: function () {
			            var clone = Base.clone.call(this);
			            clone.words = this.words.slice(0);

			            return clone;
			        },

			        /**
			         * Creates a word array filled with random bytes.
			         *
			         * @param {number} nBytes The number of random bytes to generate.
			         *
			         * @return {WordArray} The random word array.
			         *
			         * @static
			         *
			         * @example
			         *
			         *     var wordArray = CryptoJS.lib.WordArray.random(16);
			         */
			        random: function (nBytes) {
			            var words = [];

			            for (var i = 0; i < nBytes; i += 4) {
			                words.push(cryptoSecureRandomInt());
			            }

			            return new WordArray.init(words, nBytes);
			        }
			    });

			    /**
			     * Encoder namespace.
			     */
			    var C_enc = C.enc = {};

			    /**
			     * Hex encoding strategy.
			     */
			    var Hex = C_enc.Hex = {
			        /**
			         * Converts a word array to a hex string.
			         *
			         * @param {WordArray} wordArray The word array.
			         *
			         * @return {string} The hex string.
			         *
			         * @static
			         *
			         * @example
			         *
			         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
			         */
			        stringify: function (wordArray) {
			            // Shortcuts
			            var words = wordArray.words;
			            var sigBytes = wordArray.sigBytes;

			            // Convert
			            var hexChars = [];
			            for (var i = 0; i < sigBytes; i++) {
			                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
			                hexChars.push((bite >>> 4).toString(16));
			                hexChars.push((bite & 0x0f).toString(16));
			            }

			            return hexChars.join('');
			        },

			        /**
			         * Converts a hex string to a word array.
			         *
			         * @param {string} hexStr The hex string.
			         *
			         * @return {WordArray} The word array.
			         *
			         * @static
			         *
			         * @example
			         *
			         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
			         */
			        parse: function (hexStr) {
			            // Shortcut
			            var hexStrLength = hexStr.length;

			            // Convert
			            var words = [];
			            for (var i = 0; i < hexStrLength; i += 2) {
			                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
			            }

			            return new WordArray.init(words, hexStrLength / 2);
			        }
			    };

			    /**
			     * Latin1 encoding strategy.
			     */
			    var Latin1 = C_enc.Latin1 = {
			        /**
			         * Converts a word array to a Latin1 string.
			         *
			         * @param {WordArray} wordArray The word array.
			         *
			         * @return {string} The Latin1 string.
			         *
			         * @static
			         *
			         * @example
			         *
			         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
			         */
			        stringify: function (wordArray) {
			            // Shortcuts
			            var words = wordArray.words;
			            var sigBytes = wordArray.sigBytes;

			            // Convert
			            var latin1Chars = [];
			            for (var i = 0; i < sigBytes; i++) {
			                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
			                latin1Chars.push(String.fromCharCode(bite));
			            }

			            return latin1Chars.join('');
			        },

			        /**
			         * Converts a Latin1 string to a word array.
			         *
			         * @param {string} latin1Str The Latin1 string.
			         *
			         * @return {WordArray} The word array.
			         *
			         * @static
			         *
			         * @example
			         *
			         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
			         */
			        parse: function (latin1Str) {
			            // Shortcut
			            var latin1StrLength = latin1Str.length;

			            // Convert
			            var words = [];
			            for (var i = 0; i < latin1StrLength; i++) {
			                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
			            }

			            return new WordArray.init(words, latin1StrLength);
			        }
			    };

			    /**
			     * UTF-8 encoding strategy.
			     */
			    var Utf8 = C_enc.Utf8 = {
			        /**
			         * Converts a word array to a UTF-8 string.
			         *
			         * @param {WordArray} wordArray The word array.
			         *
			         * @return {string} The UTF-8 string.
			         *
			         * @static
			         *
			         * @example
			         *
			         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
			         */
			        stringify: function (wordArray) {
			            try {
			                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
			            } catch (e) {
			                throw new Error('Malformed UTF-8 data');
			            }
			        },

			        /**
			         * Converts a UTF-8 string to a word array.
			         *
			         * @param {string} utf8Str The UTF-8 string.
			         *
			         * @return {WordArray} The word array.
			         *
			         * @static
			         *
			         * @example
			         *
			         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
			         */
			        parse: function (utf8Str) {
			            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
			        }
			    };

			    /**
			     * Abstract buffered block algorithm template.
			     *
			     * The property blockSize must be implemented in a concrete subtype.
			     *
			     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
			     */
			    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
			        /**
			         * Resets this block algorithm's data buffer to its initial state.
			         *
			         * @example
			         *
			         *     bufferedBlockAlgorithm.reset();
			         */
			        reset: function () {
			            // Initial values
			            this._data = new WordArray.init();
			            this._nDataBytes = 0;
			        },

			        /**
			         * Adds new data to this block algorithm's buffer.
			         *
			         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
			         *
			         * @example
			         *
			         *     bufferedBlockAlgorithm._append('data');
			         *     bufferedBlockAlgorithm._append(wordArray);
			         */
			        _append: function (data) {
			            // Convert string to WordArray, else assume WordArray already
			            if (typeof data == 'string') {
			                data = Utf8.parse(data);
			            }

			            // Append
			            this._data.concat(data);
			            this._nDataBytes += data.sigBytes;
			        },

			        /**
			         * Processes available data blocks.
			         *
			         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
			         *
			         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
			         *
			         * @return {WordArray} The processed data.
			         *
			         * @example
			         *
			         *     var processedData = bufferedBlockAlgorithm._process();
			         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
			         */
			        _process: function (doFlush) {
			            var processedWords;

			            // Shortcuts
			            var data = this._data;
			            var dataWords = data.words;
			            var dataSigBytes = data.sigBytes;
			            var blockSize = this.blockSize;
			            var blockSizeBytes = blockSize * 4;

			            // Count blocks ready
			            var nBlocksReady = dataSigBytes / blockSizeBytes;
			            if (doFlush) {
			                // Round up to include partial blocks
			                nBlocksReady = Math.ceil(nBlocksReady);
			            } else {
			                // Round down to include only full blocks,
			                // less the number of blocks that must remain in the buffer
			                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
			            }

			            // Count words ready
			            var nWordsReady = nBlocksReady * blockSize;

			            // Count bytes ready
			            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

			            // Process blocks
			            if (nWordsReady) {
			                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
			                    // Perform concrete-algorithm logic
			                    this._doProcessBlock(dataWords, offset);
			                }

			                // Remove processed words
			                processedWords = dataWords.splice(0, nWordsReady);
			                data.sigBytes -= nBytesReady;
			            }

			            // Return processed words
			            return new WordArray.init(processedWords, nBytesReady);
			        },

			        /**
			         * Creates a copy of this object.
			         *
			         * @return {Object} The clone.
			         *
			         * @example
			         *
			         *     var clone = bufferedBlockAlgorithm.clone();
			         */
			        clone: function () {
			            var clone = Base.clone.call(this);
			            clone._data = this._data.clone();

			            return clone;
			        },

			        _minBufferSize: 0
			    });

			    /**
			     * Abstract hasher template.
			     *
			     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
			     */
			    C_lib.Hasher = BufferedBlockAlgorithm.extend({
			        /**
			         * Configuration options.
			         */
			        cfg: Base.extend(),

			        /**
			         * Initializes a newly created hasher.
			         *
			         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
			         *
			         * @example
			         *
			         *     var hasher = CryptoJS.algo.SHA256.create();
			         */
			        init: function (cfg) {
			            // Apply config defaults
			            this.cfg = this.cfg.extend(cfg);

			            // Set initial values
			            this.reset();
			        },

			        /**
			         * Resets this hasher to its initial state.
			         *
			         * @example
			         *
			         *     hasher.reset();
			         */
			        reset: function () {
			            // Reset data buffer
			            BufferedBlockAlgorithm.reset.call(this);

			            // Perform concrete-hasher logic
			            this._doReset();
			        },

			        /**
			         * Updates this hasher with a message.
			         *
			         * @param {WordArray|string} messageUpdate The message to append.
			         *
			         * @return {Hasher} This hasher.
			         *
			         * @example
			         *
			         *     hasher.update('message');
			         *     hasher.update(wordArray);
			         */
			        update: function (messageUpdate) {
			            // Append
			            this._append(messageUpdate);

			            // Update the hash
			            this._process();

			            // Chainable
			            return this;
			        },

			        /**
			         * Finalizes the hash computation.
			         * Note that the finalize operation is effectively a destructive, read-once operation.
			         *
			         * @param {WordArray|string} messageUpdate (Optional) A final message update.
			         *
			         * @return {WordArray} The hash.
			         *
			         * @example
			         *
			         *     var hash = hasher.finalize();
			         *     var hash = hasher.finalize('message');
			         *     var hash = hasher.finalize(wordArray);
			         */
			        finalize: function (messageUpdate) {
			            // Final message update
			            if (messageUpdate) {
			                this._append(messageUpdate);
			            }

			            // Perform concrete-hasher logic
			            var hash = this._doFinalize();

			            return hash;
			        },

			        blockSize: 512/32,

			        /**
			         * Creates a shortcut function to a hasher's object interface.
			         *
			         * @param {Hasher} hasher The hasher to create a helper for.
			         *
			         * @return {Function} The shortcut function.
			         *
			         * @static
			         *
			         * @example
			         *
			         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
			         */
			        _createHelper: function (hasher) {
			            return function (message, cfg) {
			                return new hasher.init(cfg).finalize(message);
			            };
			        },

			        /**
			         * Creates a shortcut function to the HMAC's object interface.
			         *
			         * @param {Hasher} hasher The hasher to use in this HMAC helper.
			         *
			         * @return {Function} The shortcut function.
			         *
			         * @static
			         *
			         * @example
			         *
			         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
			         */
			        _createHmacHelper: function (hasher) {
			            return function (message, key) {
			                return new C_algo.HMAC.init(hasher, key).finalize(message);
			            };
			        }
			    });

			    /**
			     * Algorithm namespace.
			     */
			    var C_algo = C.algo = {};

			    return C;
			}(Math));


			return CryptoJS;

		})); 
	} (core));
	return core.exports;
}

(function (module, exports) {
(function (root, factory) {
		{
			// CommonJS
			module.exports = factory(requireCore());
		}
	}(commonjsGlobal, function (CryptoJS) {

		(function (Math) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_algo = C.algo;

		    // Constants table
		    var T = [];

		    // Compute constants
		    (function () {
		        for (var i = 0; i < 64; i++) {
		            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
		        }
		    }());

		    /**
		     * MD5 hash algorithm.
		     */
		    var MD5 = C_algo.MD5 = Hasher.extend({
		        _doReset: function () {
		            this._hash = new WordArray.init([
		                0x67452301, 0xefcdab89,
		                0x98badcfe, 0x10325476
		            ]);
		        },

		        _doProcessBlock: function (M, offset) {
		            // Swap endian
		            for (var i = 0; i < 16; i++) {
		                // Shortcuts
		                var offset_i = offset + i;
		                var M_offset_i = M[offset_i];

		                M[offset_i] = (
		                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
		                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
		                );
		            }

		            // Shortcuts
		            var H = this._hash.words;

		            var M_offset_0  = M[offset + 0];
		            var M_offset_1  = M[offset + 1];
		            var M_offset_2  = M[offset + 2];
		            var M_offset_3  = M[offset + 3];
		            var M_offset_4  = M[offset + 4];
		            var M_offset_5  = M[offset + 5];
		            var M_offset_6  = M[offset + 6];
		            var M_offset_7  = M[offset + 7];
		            var M_offset_8  = M[offset + 8];
		            var M_offset_9  = M[offset + 9];
		            var M_offset_10 = M[offset + 10];
		            var M_offset_11 = M[offset + 11];
		            var M_offset_12 = M[offset + 12];
		            var M_offset_13 = M[offset + 13];
		            var M_offset_14 = M[offset + 14];
		            var M_offset_15 = M[offset + 15];

		            // Working variables
		            var a = H[0];
		            var b = H[1];
		            var c = H[2];
		            var d = H[3];

		            // Computation
		            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
		            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
		            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
		            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
		            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
		            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
		            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
		            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
		            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
		            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
		            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
		            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
		            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
		            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
		            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
		            b = FF(b, c, d, a, M_offset_15, 22, T[15]);

		            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
		            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
		            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
		            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
		            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
		            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
		            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
		            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
		            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
		            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
		            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
		            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
		            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
		            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
		            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
		            b = GG(b, c, d, a, M_offset_12, 20, T[31]);

		            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
		            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
		            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
		            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
		            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
		            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
		            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
		            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
		            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
		            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
		            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
		            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
		            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
		            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
		            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
		            b = HH(b, c, d, a, M_offset_2,  23, T[47]);

		            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
		            d = II(d, a, b, c, M_offset_7,  10, T[49]);
		            c = II(c, d, a, b, M_offset_14, 15, T[50]);
		            b = II(b, c, d, a, M_offset_5,  21, T[51]);
		            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
		            d = II(d, a, b, c, M_offset_3,  10, T[53]);
		            c = II(c, d, a, b, M_offset_10, 15, T[54]);
		            b = II(b, c, d, a, M_offset_1,  21, T[55]);
		            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
		            d = II(d, a, b, c, M_offset_15, 10, T[57]);
		            c = II(c, d, a, b, M_offset_6,  15, T[58]);
		            b = II(b, c, d, a, M_offset_13, 21, T[59]);
		            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
		            d = II(d, a, b, c, M_offset_11, 10, T[61]);
		            c = II(c, d, a, b, M_offset_2,  15, T[62]);
		            b = II(b, c, d, a, M_offset_9,  21, T[63]);

		            // Intermediate hash value
		            H[0] = (H[0] + a) | 0;
		            H[1] = (H[1] + b) | 0;
		            H[2] = (H[2] + c) | 0;
		            H[3] = (H[3] + d) | 0;
		        },

		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;

		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;

		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);

		            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
		            var nBitsTotalL = nBitsTotal;
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
		                (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
		                (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
		            );
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
		                (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
		                (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
		            );

		            data.sigBytes = (dataWords.length + 1) * 4;

		            // Hash final blocks
		            this._process();

		            // Shortcuts
		            var hash = this._hash;
		            var H = hash.words;

		            // Swap endian
		            for (var i = 0; i < 4; i++) {
		                // Shortcut
		                var H_i = H[i];

		                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
		                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
		            }

		            // Return final computed hash
		            return hash;
		        },

		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();

		            return clone;
		        }
		    });

		    function FF(a, b, c, d, x, s, t) {
		        var n = a + ((b & c) | (~b & d)) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }

		    function GG(a, b, c, d, x, s, t) {
		        var n = a + ((b & d) | (c & ~d)) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }

		    function HH(a, b, c, d, x, s, t) {
		        var n = a + (b ^ c ^ d) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }

		    function II(a, b, c, d, x, s, t) {
		        var n = a + (c ^ (b | ~d)) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }

		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.MD5('message');
		     *     var hash = CryptoJS.MD5(wordArray);
		     */
		    C.MD5 = Hasher._createHelper(MD5);

		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacMD5(message, key);
		     */
		    C.HmacMD5 = Hasher._createHmacHelper(MD5);
		}(Math));


		return CryptoJS.MD5;

	})); 
} (md5$1));

var md5Exports = md5$1.exports;
const cryptoMd5 = /*@__PURE__*/getDefaultExportFromCjs(md5Exports);

const hexList = "0123456789abcdef";
function buildUUID() {
  let uuid = "";
  for (let i = 1; i <= 36; i++) {
    if (i === 9 || i === 14 || i === 19 || i === 24)
      uuid += "-";
    else if (i === 15)
      uuid += "4";
    else if (i === 20)
      uuid += hexList[Math.random() * 4 | 8];
    else
      uuid += hexList[Math.random() * 16 | 0];
  }
  return uuid.replace(/-/g, "");
}
let unique = 0;
function buildShortUUID(prefix = "") {
  const time = Date.now();
  const random = Math.floor(Math.random() * 1e9);
  unique++;
  return `${prefix}_${random}${unique}${String(time)}`;
}
function md5(key) {
  return cryptoMd5(key).toString();
}
function sortRecordByProperty(record) {
  return Object.fromEntries(
    Object.entries(record).sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
  );
}
function shopMd5(body = {}) {
  const { appKey } = getGlobalConfig();
  const timestamp = (/* @__PURE__ */ new Date()).getTime().toString();
  const nonce = buildShortUUID(buildUUID());
  const sortQuery = sortRecordByProperty({ ...body, nonce, timestamp });
  let md5key = withQuery("", { ...sortQuery, key: appKey }).substring(1);
  md5key = md5key.replaceAll("+", " ");
  const sign = md5(decodeURIComponent(md5key));
  return { ...body, timestamp, nonce, sign };
}
function payMd5(body = {}) {
  const { payKey, appId } = getGlobalConfig();
  const time = (/* @__PURE__ */ new Date()).getTime().toString();
  const sortQuery = sortRecordByProperty({ ...body });
  const md5key = JSON.stringify(sortQuery) + time + payKey;
  const paySign = md5(md5key);
  return { time, paySign, appId: `${appId}` };
}

function preCheckTpApi(partner, tp) {
  const api = "/api/mall/commodity/{name}/order/pre-check" /* PRE_CHECK_TP */.replace("{name}", partner);
  const params = shopMd5({ tp });
  return shopHttp(api, { method: "get", params });
}
function createShopPayOrderApi({ tp, ...body }) {
  const params = shopMd5(body);
  console.log("createShopPayOrderApi", params, body);
  return shopHttp("/api/mall/commodity/place/order/v2" /* CREATE_PAY_ORDER */, { method: "post", params, data: { tp, ...body } });
}
function getShopPayOrderByIdApi(orderId) {
  const params = shopMd5({ orderId });
  return shopHttp(`${"/api/mall/commodity/order/info" /* PAY_ORDER_INFO */}/${orderId}`, { method: "get", params });
}
function getShopPayCountryListApi(coin) {
  return shopHttp("/member/pay/config/list/channel" /* PAY_COUNTRY_LIST */, { method: "get", params: { coin } });
}
function comfirmShopPayOrderApi(data) {
  const headers = payMd5(data);
  return shopHttp("/member/pay/order/space/customize" /* COMFIRM_PAY */, { method: "post", data, headers });
}
function getShopOrderListApi(data) {
  const headers = shopMd5(data);
  return shopHttp("/api/orderCenter/order/list" /* PAY_ORDER_LIST */, { method: "post", data, headers });
}
function closeShopOrderByIdApi(orderId) {
  const params = shopMd5({ orderId });
  return shopHttp(`${"/api/mall/commodity/close/order" /* CLOSE_ORDER */}/${orderId}`, { method: "post", params });
}
function getShopConsumeListApi({ page }) {
  const { uid } = getGlobalConfig();
  const data = { page, userId: uid };
  const headers = payMd5(data);
  return shopHttp("/member/pay/coin/pay/user/order" /* CONSUME_LIST */, { method: "post", data, headers });
}

function getShopInfoByAuthApi(params) {
  const { locale } = getGlobalConfig();
  const data = { ...params, countryCode: locale };
  return shopHttp("/member/user/assistant/login" /* LOGIN */, { method: "post", data });
}

const globalConfig = {
  develop: false,
  baseUrl: "",
  locale: "en",
  appId: "666600001",
  appKey: "nUPFCvEKy3jExA8v",
  payKey: "4405e9f9c5a9acffd9cc411c2952aab1",
  // 请求头参数
  shareuid: "",
  source: "",
  channel: "",
  shopToken: "",
  // 接口参数
  currency: "",
  uid: "",
  channelId: "0",
  subChannelId: "0",
  // 中台参数
  platformToken: "",
  platformUid: ""
};
function getSupportLocale(locale) {
  const supportLocale = ["tw", "en", "kr", "jp", "vn", "th", "br", "fr", "ru", "id"];
  if (locale === "pt")
    return "br";
  else if (supportLocale.includes(locale))
    return locale;
  return "en";
}
async function getInitCurrency() {
  const currencyList = await getShopCurrencyListApi();
  const item = find(currencyList, "select");
  return item?.currency || currencyList[0].currency;
}
async function updateGlobalConfig(params) {
  if (isBoolean(params.develop))
    globalConfig.baseUrl = params.develop ? "https://debug.ld-space.com" : "https://api.ldshop.gg";
  if (params.locale)
    params.locale = getSupportLocale(params.locale);
  entries(params).forEach(([key, value]) => {
    if (has(globalConfig, key))
      globalConfig[key] = value;
  });
  if (!globalConfig.currency)
    globalConfig.currency = await getInitCurrency();
  return getGlobalConfig();
}
function getGlobalConfig() {
  return { ...globalConfig };
}

var ShopOrderStatus = /* @__PURE__ */ ((ShopOrderStatus2) => {
  ShopOrderStatus2[ShopOrderStatus2["TO_BE_PAID"] = 0] = "TO_BE_PAID";
  ShopOrderStatus2[ShopOrderStatus2["PAID"] = 1] = "PAID";
  ShopOrderStatus2[ShopOrderStatus2["SHIPPING"] = 2] = "SHIPPING";
  ShopOrderStatus2[ShopOrderStatus2["FINISHED"] = 3] = "FINISHED";
  ShopOrderStatus2[ShopOrderStatus2["CANCELED"] = 4] = "CANCELED";
  ShopOrderStatus2[ShopOrderStatus2["EXCEPTION"] = 5] = "EXCEPTION";
  ShopOrderStatus2[ShopOrderStatus2["TP_FAILED"] = 30] = "TP_FAILED";
  ShopOrderStatus2[ShopOrderStatus2["REFUNDED"] = 99] = "REFUNDED";
  return ShopOrderStatus2;
})(ShopOrderStatus || {});
var ShopOrderListStatus = /* @__PURE__ */ ((ShopOrderListStatus2) => {
  ShopOrderListStatus2["TO_BE_PAID"] = "PAY_STATUS_INIT";
  ShopOrderListStatus2["IN_PROGRESS"] = "PAY_STATUS_PROGRESS";
  ShopOrderListStatus2["FINISHED"] = "PAY_STATUS_COMPLETE";
  ShopOrderListStatus2["CANCELED"] = "PAY_STATUS_CANCEL";
  ShopOrderListStatus2["AFTER_SALE"] = "PAY_STATUS_REFUND_AFTERMARKET";
  return ShopOrderListStatus2;
})(ShopOrderListStatus || {});
var ShopOrderCode = /* @__PURE__ */ ((ShopOrderCode2) => {
  ShopOrderCode2[ShopOrderCode2["COMMODITY_SOLD_OUT"] = 4001] = "COMMODITY_SOLD_OUT";
  ShopOrderCode2[ShopOrderCode2["ORDER_CLOSE_ERROR"] = 4002] = "ORDER_CLOSE_ERROR";
  ShopOrderCode2[ShopOrderCode2["ORDER_CLOSE_SUCCESS"] = 4003] = "ORDER_CLOSE_SUCCESS";
  ShopOrderCode2[ShopOrderCode2["ORDER_NOT_EXIST"] = 4004] = "ORDER_NOT_EXIST";
  ShopOrderCode2[ShopOrderCode2["CHECK_ORDER_STATUS_FAILD"] = 4005] = "CHECK_ORDER_STATUS_FAILD";
  ShopOrderCode2[ShopOrderCode2["ORDER_NOT_CREATE"] = 4006] = "ORDER_NOT_CREATE";
  ShopOrderCode2[ShopOrderCode2["SKU_NOT_EXIST"] = 4007] = "SKU_NOT_EXIST";
  ShopOrderCode2[ShopOrderCode2["COMMODITY_NOT_EXIST"] = 4008] = "COMMODITY_NOT_EXIST";
  ShopOrderCode2[ShopOrderCode2["ORDER_TO_BE_PAY"] = 4009] = "ORDER_TO_BE_PAY";
  ShopOrderCode2[ShopOrderCode2["VALID_ERROR"] = 4010] = "VALID_ERROR";
  ShopOrderCode2[ShopOrderCode2["ORDER_STATUS_ERROR"] = 4030] = "ORDER_STATUS_ERROR";
  ShopOrderCode2[ShopOrderCode2["ORDER_IS_PAID"] = 3002] = "ORDER_IS_PAID";
  ShopOrderCode2[ShopOrderCode2["BALANCE_NOT_ENOUGH"] = 3003] = "BALANCE_NOT_ENOUGH";
  ShopOrderCode2[ShopOrderCode2["COUPON_NOT_EXIST"] = 3004] = "COUPON_NOT_EXIST";
  ShopOrderCode2[ShopOrderCode2["COUPON_NOT_MATCH"] = 3005] = "COUPON_NOT_MATCH";
  return ShopOrderCode2;
})(ShopOrderCode || {});

function initShopSku() {
  return {
    attribution: "",
    commodityName: "",
    skuId: 0,
    skuName: "",
    storageId: 0,
    price: 0,
    maxDiscount: "",
    originalPrice: 0,
    originalCurrencyPrice: 0,
    icon: "",
    language: "",
    localizedCurrencyPrice: "",
    type: 0,
    stock: 0,
    partner: "",
    currency: "",
    currencyPrice: 0
  };
}
function initShopCustomTranslate() {
  return {
    language: {},
    lastCacheTime: 0
  };
}
function initComfirmShopPayOrderParams() {
  const { appId, uid } = getGlobalConfig();
  return {
    appId,
    subChannelId: "0",
    source: "2",
    channelId: "0",
    cpUid: uid,
    uid,
    // 需传参
    coin: "",
    cpOrderId: "",
    productName: "",
    payChannelConfId: "",
    userCouponId: ""
  };
}
function initShopUserInfo() {
  return {
    userId: "",
    topicType: 0,
    bgImg: "",
    content: "",
    nickName: "",
    avatar: "",
    userName: "",
    email: "",
    countryCode: "",
    area: "",
    bindType: "",
    light: 0,
    lightStatus: 0,
    likeNum: 0,
    notifyStatus: 0,
    isReg: 0,
    spaceToken: "",
    cpToken: "",
    outUserId: "",
    googleAccount: ""
  };
}

function renderSchemas$3(sku) {
  const tpConfig = sku.tp;
  if (!tpConfig?.template)
    return [];
  const inputSchema = ({ tag, field }) => {
    return {
      field,
      label: tag,
      componentName: "input"
    };
  };
  const selectSchema = ({ tag, field, options }) => {
    return {
      field,
      label: tag,
      componentName: "select",
      /** 额外的参数 全部列表，用于下面联动过滤使用 */
      defaultOptions: options,
      watchField: field === "charge_server" ? "charge_region" : void 0,
      componentProps: ({ schema, formModel, getSchemaByField }) => {
        let options2 = schema.defaultOptions;
        if (schema.field === "charge_server" && formModel.charge_region) {
          formModel.charge_server = void 0;
          const regionList = getSchemaByField("charge_region")?.defaultOptions || [];
          if (regionList?.length) {
            const selRegion = regionList?.find(({ name }) => name === formModel.charge_region);
            options2 = options2?.filter(({ parentId }) => parentId === selRegion?.id) || [];
          }
        }
        return {
          options: options2,
          labelField: "name",
          valueField: "name"
        };
      }
    };
  };
  return tpConfig.template.map((i) => i.options ? selectSchema(i) : inputSchema(i));
}
function generateTpParams$4({ sku, formModel }) {
  const { source } = getGlobalConfig();
  const { tp } = unref(sku);
  if (!tp) {
    return JSON.stringify({ source });
  } else {
    const { product_id, type } = tp;
    return JSON.stringify({
      ...unref(formModel),
      source,
      product_id,
      type
    });
  }
}
async function validate$2(sku, tpParams) {
  const { tp } = unref(sku);
  if (!tp || tp.type !== 1)
    return 200;
  try {
    await preCheckTpApi(tp.partner, tpParams);
    return 200;
  } catch (error) {
    const code = error?.code ?? ShopOrderCode.VALID_ERROR;
    console.log("SmileOne valid error", error);
    return code;
  }
}
const Topup = { renderSchemas: renderSchemas$3, generateTpParams: generateTpParams$4, validate: validate$2 };

function generateTpParams$3({
  sku,
  formModel
}) {
  const { source } = getGlobalConfig();
  const { tp } = unref(sku);
  if (!tp) {
    return JSON.stringify({ source });
  } else {
    const { product_id, type } = tp;
    return JSON.stringify({ ...unref(formModel), source, product_id, type });
  }
}
const LdSpace = { generateTpParams: generateTpParams$3 };

function renderSchemas$2(sku) {
  const tpConfig = sku.tp;
  if (!tpConfig?.template)
    return [];
  const inputSchema = ({ tag, field }) => {
    return {
      field,
      label: tag,
      componentName: "input"
    };
  };
  const selectSchema = ({ tag, field, options }) => {
    return {
      field,
      label: tag,
      componentName: "select",
      componentProps: {
        options,
        labelField: "name",
        valueField: "id"
      }
    };
  };
  return tpConfig.template.map((i) => i.options ? selectSchema(i) : inputSchema(i));
}
function generateTpParams$2({
  sku,
  formModel
}) {
  const { source } = getGlobalConfig();
  const { tp } = unref(sku);
  if (!tp) {
    return JSON.stringify({ source });
  } else {
    const { product_id, type } = tp;
    return JSON.stringify({ ...unref(formModel), source, product_id, type });
  }
}
async function validate$1(sku, tpParams) {
  const { tp } = unref(sku);
  if (!tp || tp.type !== 1)
    return 200;
  try {
    await preCheckTpApi(tp.partner, tpParams);
    return 200;
  } catch (error) {
    const code = error?.code ?? ShopOrderCode.VALID_ERROR;
    console.log("Jollymax valid error", error);
    return code;
  }
}
const Jollymax = { renderSchemas: renderSchemas$2, generateTpParams: generateTpParams$2, validate: validate$1 };

function useShopTranslate() {
  const { locale } = getGlobalConfig();
  const translateContent = useStorage("TranslateContent", initShopCustomTranslate());
  async function getTranslate() {
    try {
      translateContent.value = await getShopCustomTranslateApi();
    } catch (error) {
    }
  }
  function watchSyncTranslate() {
    getTranslate();
    const TIMES = 1e3 * 60 * 30;
    setInterval(getTranslate, TIMES);
  }
  function getShopTranslate() {
    return translateContent.value.language?.[locale] || {};
  }
  function getStoredTextsByOrder(order) {
    const translateMap = getShopTranslate();
    const data = JSON.parse(order.displayTp || "{}");
    const renderData = Object.entries(data).map(([title, value]) => ({ label: translateMap[title] || title, value }));
    return { renderData };
  }
  function getCardCodeByOrder(order) {
    const translateMap = getShopTranslate();
    const data = JSON.parse(order.redeemCodeJson || "{}");
    if (order.partner === "big_player") {
      return {
        renderData: data.map(({ title, value }) => ({ label: translateMap[title] || title, value })),
        expirationDate: data.expirationDate
      };
    } else {
      const { cardNumber, cardPin, redeemUrl, expirationDate } = data;
      const renderData = [
        { label: translateMap["\u5361\u865F"], value: cardNumber },
        { label: translateMap["\u5BC6\u78BC"], value: cardPin },
        { label: translateMap["\u514C\u6362\u5546\u54C1\u9023\u7D50"], value: redeemUrl }
      ];
      return {
        renderData: renderData.filter(({ value }) => !value),
        expirationDate
      };
    }
  }
  return {
    /** 定期同步翻译 */
    watchSyncTranslate,
    /** 获取第三方翻译 */
    getShopTranslate,
    /**
     * 根据订单信息返回用户填写的充值信息
     * @param order 订单内容
     * @return object {renderData: {label: 标签, value: 内容}}
     */
    getStoredTextsByOrder,
    /**
     * 根据订单信息返回点卡信息
     * @param order 订单内容
     * @return object {renderData: {label: 标签, value: 内容}, expirationDate: 过期时间}
     */
    getCardCodeByOrder
  };
}

function isInput(type) {
  return type === "TextControl" || isPwdInput(type) || isNubInput(type);
}
function isPwdInput(type) {
  return type === "PasswordControl";
}
function isNubInput(type) {
  return type === "NumericControl";
}
function isSelect(type) {
  return type === "SingleSelectControl" || type === "DropDownSingleSelectControl" || isMultipleSelect(type);
}
function isMultipleSelect(type) {
  return type === "MultiSelectControl" || type === "DropDownMultiSelectControl";
}
function renderInput(control) {
  const { type, maxValue, minValue, maxLength, minLength } = control;
  return {
    componentName: "input",
    componentProps: {
      type: isPwdInput(type) ? "password" : "text",
      showPassword: isPwdInput(type),
      maxLength: maxValue || maxLength || 10,
      minLength: minValue || minLength || 1
    }
  };
}
function renderSelect(control) {
  const { type, options } = control;
  const { getShopTranslate } = useShopTranslate();
  const labelDict = getShopTranslate();
  return {
    componentName: "select",
    componentProps: {
      options: (options || []).map((label) => ({ label: labelDict?.[label] || label, value: label })),
      labelField: "label",
      valueField: "value",
      clearable: true,
      multiple: isMultipleSelect(type)
    }
  };
}
function getControlConfig(sku) {
  const sections = sku.tp?.template?.sections || [];
  const tables = sections.flatMap(({ tables: tables2 }) => tables2) || [];
  const config = tables.flatMap(
    ({ headers, controls }, key) => controls.flatMap(
      (ctrls, inx) => ctrls.map((control, i) => {
        const label = headers[inx].title;
        return {
          label,
          field: `${key}-${i}-${label}`,
          // 唯一关键key
          control
        };
      })
    )
  );
  const map = keyBy(config, "field");
  return { map, list: config };
}
function getComponentInfo({ label, field, control }) {
  const { type } = control;
  const { getShopTranslate } = useShopTranslate();
  const labelDict = getShopTranslate();
  if (isInput(type))
    return { label: labelDict[label] ?? label, field, ...renderInput(control) };
  else if (isSelect(type))
    return { label: labelDict[label] ?? label, field, ...renderSelect(control) };
  return void 0;
}
function renderSchemas$1(sku) {
  const { list } = getControlConfig(sku);
  return list.map(getComponentInfo).filter(Boolean);
}
function generateTpParams$1({
  sku,
  formModel
}) {
  const { source } = getGlobalConfig();
  const copySku = cloneDeep(unref(sku));
  const { map } = getControlConfig(copySku);
  Object.entries(unref(formModel)).forEach(([key, value]) => {
    const control = map[key].control;
    if (isMultipleSelect(control.type))
      control.values = value;
    else
      control.value = value;
  });
  return JSON.stringify({ ...copySku.tp, source });
}
const BigPlayer = { renderSchemas: renderSchemas$1, generateTpParams: generateTpParams$1 };

function renderSchemas(sku) {
  const tpConfig = sku.tp;
  if (!tpConfig?.template)
    return [];
  const inputSchema = ({ tag, field }) => {
    return {
      field,
      label: tag,
      componentName: "input"
    };
  };
  const selectSchema = ({ tag, field, options }) => {
    return {
      field,
      label: tag,
      componentName: "select",
      /** 额外的参数 全部列表，用于下面联动过滤使用 */
      defaultOptions: options,
      watchField: field === "charge_server" ? "charge_region" : void 0,
      componentProps: ({ schema, formModel, getSchemaByField }) => {
        let options2 = schema.defaultOptions;
        if (schema.field === "charge_server" && formModel.charge_region) {
          formModel.charge_server = void 0;
          const regionList = getSchemaByField("charge_region")?.defaultOptions || [];
          if (regionList?.length) {
            const selRegion = regionList?.find(({ name }) => name === formModel.charge_region);
            options2 = options2?.filter(({ parentId }) => parentId === selRegion?.id) || [];
          }
        }
        return {
          options: options2,
          labelField: "name",
          valueField: "name"
        };
      }
    };
  };
  return tpConfig.template.map((i) => i.options ? selectSchema(i) : inputSchema(i));
}
function generateTpParams({
  sku,
  formModel
}) {
  const { source, locale } = getGlobalConfig();
  const { tp, skuId } = unref(sku);
  if (!tp)
    return JSON.stringify({ source });
  const { product_id, type, product } = tp;
  return JSON.stringify({
    ...unref(formModel),
    source,
    product_id,
    type,
    skuId,
    product,
    countryCode: locale
  });
}
async function validate(sku, tpParams) {
  const { tp } = unref(sku);
  if (!tp || tp.type !== 1)
    return 200;
  try {
    await preCheckTpApi(tp.partner, tpParams);
    return 200;
  } catch (error) {
    const code = error?.code ?? ShopOrderCode.VALID_ERROR;
    console.log("SmileOne valid error", error);
    return code;
  }
}
const SmileOne = { renderSchemas, generateTpParams, validate };

function useSkuTpFormAction() {
  const sku = ref(initShopSku());
  const formModel = ref({});
  function reset() {
    sku.value = initShopSku();
    formModel.value = {};
  }
  function getPartnerfn() {
    const partnerKey = {
      "top-up": Topup,
      "jollymax": Jollymax,
      "big_player": BigPlayer,
      "ldspace": LdSpace,
      "smile-one": SmileOne
    };
    return partnerKey[sku.value.partner];
  }
  function renderSchemasByTp(commoditySku) {
    reset();
    sku.value = commoditySku;
    const fn = getPartnerfn();
    return fn?.renderSchemas?.(sku.value) ?? [];
  }
  function getTpParamsBySchemas() {
    const fn = getPartnerfn();
    return fn?.generateTpParams?.({ sku, formModel }) ?? "";
  }
  async function partnerValidate(tpParams) {
    const fn = getPartnerfn();
    return fn?.validate?.(sku, tpParams) ?? 200;
  }
  return {
    /** 渲染表单数据 */
    formModel,
    /** 根据不同的partner(供应商)模板生成表单schema */
    renderSchemasByTp,
    /** 根据表单schema的值和partner(供应商)生成对应所需提交参数 */
    getTpParamsBySchemas,
    /**
     * 合作方的校验
     * @param {string} tpParams tp字符串
     */
    partnerValidate
  };
}

function useShopPayAction() {
  return {
    /**
     * 商城币抵扣的额度 和 额外需支付的金额
     * @param order 商城订单信息
     * @param userCoin 用户可用商城币余额
     */
    getDeductionAndNeedPay,
    /**
     * 确认支付订单，返回支付链接
     * @param order 商城订单信息
     * @param payChannelConfId 支付方式ID
     */
    comfirmPayOrder
  };
}
function getDeductionAndNeedPay(order, userCoin) {
  const skuCoin = order.price || 0;
  const deduction = userCoin >= skuCoin ? skuCoin : userCoin;
  const needPay = skuCoin - deduction || 0;
  return { deduction, needPay };
}
function comfirmPayOrder(order, payChannelConfId) {
  const { orderId, skuName, price } = order;
  const data = Object.assign(initComfirmShopPayOrderParams(), {
    coin: `${price}`,
    cpOrderId: orderId,
    productName: skuName,
    payChannelConfId: `${payChannelConfId}`,
    userCouponId: ""
  });
  return comfirmShopPayOrderApi(data);
}

function useShopRoutePath() {
  return {
    /** 获取对应渠道的url链接 */
    getChannelHref,
    /**
     * 跳转商品详情
     * @param commodity 商品信息
     * @returns {string} 跳转路径
     */
    toCommodityDetail
  };
}
function handleLocaleHref(url, locale) {
  if (locale === "en")
    return url;
  else
    return `${url}/${locale}`;
}
function getChannelHref() {
  const { channel, locale, develop } = getGlobalConfig();
  const hrefMap = {
    /** 商城渠道 */
    /** 商城主站 */
    "ldshop": develop ? "https://pre-prod-shop.ldshop.gg" : "https://ldshop.gg",
    /** 日本合作 */
    "ldshop-jp": "https://mildom.ldshop.gg",
    /** 投放 */
    "ldshop-ad": "https://www.gamingvirtual.shop",
    /** 助手 */
    "ldplayer-x": develop ? "https://pre-prod-shop.ldshop.gg" : "https://ldshop.gg"
  };
  const url = hrefMap[channel] || hrefMap.ldshop;
  return handleLocaleHref(url, locale);
}
function getShopQuery(autoLogin = false) {
  const config = getGlobalConfig();
  const loginParams = autoLogin ? { platformToken: config.platformToken || void 0, platformUid: config.platformUid || void 0 } : {};
  return withQuery("", {
    ...loginParams,
    shareuid: config.shareuid,
    source: config.source,
    platformChannel: config.channel,
    platformCurrency: config.currency
  });
}
function toCommodityDetail(commodity, config) {
  const url = getChannelHref();
  const { commodityType, commoditySeo, commodityId } = commodity;
  const typeMap = {
    1: "top-up",
    0: "card"
  };
  const path = `${url}/${typeMap[commodityType]}/${commoditySeo || commodityId}.html`;
  const queryStr = getShopQuery(config?.autoLogin);
  return `${path}${queryStr}`;
}

function initShopSdk(params) {
  return updateGlobalConfig(params);
}
function updateShopSdkConfig(params) {
  return updateGlobalConfig(params);
}

export { ShopOrderCode, ShopOrderListStatus, ShopOrderStatus, closeShopOrderByIdApi, comfirmShopPayOrderApi, createShopPayOrderApi, getShopCommodityByPkg, getShopCommodityDetailApi, getShopCommodityListApi, getShopConsumeListApi, getShopCurrencyListApi, getShopCustomTranslateApi, getShopInfoByAuthApi, getShopOrderListApi, getShopPayCountryListApi, getShopPayOrderByIdApi, initComfirmShopPayOrderParams, initShopCustomTranslate, initShopSdk, initShopSku, initShopUserInfo, preCheckTpApi, updateShopSdkConfig, useShopPayAction, useShopRoutePath, useShopTranslate, useSkuTpFormAction };
